export default __webpack_public_path__ + "static/media/r6e_logo_zh-CN.2cd03b40.png";